import React from 'react';
import { useSelector } from 'react-redux';
import { getTopPerformersState } from '../store/selectors/topPerformersSelector';
import TopPerformers from '../TopPerformers';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import topPerformersReducer from '../store/reducers/topPerformers';

import spotlightGameDatasource from '@gameday/core/datasources/spotlightGame';
import dataAction from '../store/actions/TopPerformersDataRequestAction';
import playerStoryDataSource from '@gameday/core/datasources/playerStory';
import topPerformersWithStoriesDataAction from '../store/actions/TopPerformersWithStoriesDataRequestAction';
initContainerData.register({
    datasources: {
        spotlightGame: spotlightGameDatasource,
        playerStory: playerStoryDataSource

    },
    reducers: {
        topPerformers: topPerformersReducer
    }
});

const fetchData = () => {
    return dataAction();
};

const fetchDataWithStories = () => {
    return topPerformersWithStoriesDataAction();
};
const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const alternateRoutes = [{
    path: '/',
    exact: false,
    fetchData: fetchDataWithStories
}];

const TopPerformersDataContainer = (props) => {
    const topPerformersState = useSelector(getTopPerformersState);
    return (
        <TopPerformers {...props} { ...topPerformersState } />
    );
};

export default TopPerformersDataContainer;
export { fetchData, routes, alternateRoutes };
